import { GiftCardRepository as GiftCardRepositoryInterface } from "../../domain/repositories/GiftCardRepository"
import { GiftCardService } from "../services/GiftCardService"
import { GiftCard } from "../../domain/entities/GiftCard"
import { Filter } from "../../domain/types/transactions/Filter"

export class GiftCardRepository implements GiftCardRepositoryInterface {
	private _service

	constructor({ GiftCardService }: { GiftCardService: GiftCardService }) {
		this._service = GiftCardService
	}

	async getGiftCards(pagination: number, limit: number, filter?: Filter): Promise<GiftCard[]> {
		const response = await this._service.getGiftCards(pagination, limit, filter)
		return response.giftCards
	}
}
